<template>
<div class="chapter">
<div class="inner_page">
<h1>Copyright</h1>
<p class="sectiontop" style="text-align: center;">Diversion Books<br/>
  A Division of Diversion Publishing Corp.<br/>
  443 Park Avenue South, Suite 1008<br/>
  New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">Copyright © 2001 by Olivia Goldsmith<br/>
  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">First Diversion Books edition October 2014<br/>
  ISBN: <span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.375; text-align: justify;">978-1-62681-442-4</span></p>
<div style="page-break-after: always;">
<div style="display: none;"></div>
</div>
<h1 class="sigil_not_in_toc">More from Olivia Goldsmith</h1>
<p class="sectiontop" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Fashionably Late</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Flavor of the Month</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Marrying Mom</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Switcheroo</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">The Bestseller</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Young Wives</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Bad Boy</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Insiders</span></p>
<p class="first" style="text-align: center;"><span href="#/Text/morefrom" title="Link target outside of Sample">Wish Upon a Star</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02a_copyright.vue?5cf4f708